import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";

import { withHighlightedHeadline } from "scmp-app/components/content/content-item-render/highlight/hoc";
import { useContentItemProviders } from "scmp-app/components/content/content-item-render/hooks";
import type { ContentItemRenderVariantProps } from "scmp-app/components/content/content-item-render/types";
import type { homeSuperSplashLargeSecondaryV2ContentItemContent$key } from "scmp-app/queries/__generated__/homeSuperSplashLargeSecondaryV2ContentItemContent.graphql";

import {
  ActionBar,
  Container,
  Headline,
  HeadlineContainer,
  LiveTagContainer,
  StyledEntityLink,
} from "./styles";

export type Props = ContentItemRenderVariantProps & {
  reference: homeSuperSplashLargeSecondaryV2ContentItemContent$key;
  withComment?: boolean;
};

const Component: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  onClick,
  ref,
  reference,
  withComment = false,
}) => {
  const content = useFragment(
    graphql`
      fragment homeSuperSplashLargeSecondaryV2ContentItemContent on Content {
        entityId
        ...entityLink
        ...hooksContentItemProvidersContent
          @arguments(withHeadline: true, withLiveTag: true, withActionBar: true)
      }
    `,
    reference,
  );
  const providers = useContentItemProviders(content);

  return (
    <Container className={className} ref={ref}>
      <StyledEntityLink onClick={() => onClick?.(content.entityId)} reference={content}>
        <HeadlineContainer>
          <LiveTagContainer>{providers.liveTag({ variant: "homeV2" })}</LiveTagContainer>
          <Headline>
            {providers.headline({
              hideTooltip: true,
              preferSocialHeadline: true,
              skipHighlight: true,
            })}
          </Headline>
        </HeadlineContainer>
      </StyledEntityLink>
      <ActionBar>
        {providers.actionBar({
          commentColorVariant: "light-action-blue",
          commentIconHeight: 14,
          commentIconWidth: 14,
          isBookmarkVisible: false,
          isCommentsVisible: withComment ?? false,
          isIconVisible: false,
        })}
      </ActionBar>
    </Container>
  );
};

Component.displayName = "ContentItemHomeSuperSplashLargeSecondaryV2";

export const ContentItemHomeSuperSplashLargeSecondaryV2 = withHighlightedHeadline(Component);
